// All self-hosted <video> behavior in one module, loaded once from _layout:
// custom player controls (.video-default), responsive source selection for
// carousel slides ([data-desktop-vid]), and hover-to-play grids (.hover-videos).

const maxWidth = window.matchMedia("(max-width: 700px)");

// --- Player controls (markup from _partials/defaultVideo.twig) ---

document.querySelectorAll(".video-default").forEach((container) => {
    const video = container.querySelector("video");
    let videos = video.getAttribute("data-videos");
    const source = video.querySelector("source");

    let play = container.querySelector(".play");
    let pause = container.querySelector(".pause");

    let sound = container.querySelector(".sound");
    let muted = container.querySelector(".muted");

    let poster = container.querySelector(".poster");

    let expandContainer = container.querySelector(".expand-container");
    let expand = container.querySelector(".expand");

    // Iphone does not support the full-screen api, hiding this for now
    const agent = navigator.userAgent.toLowerCase();
    const isIPhone = agent.indexOf('iphone') !== -1;
    if (isIPhone && expandContainer) expandContainer.style.display = "none";

    function setInitial() {
        play.style.display = "none";
        pause.style.display = "block";
        if (poster) poster.style.position = "static";

        // remove sound button
        if (sound && muted) {
            if (video.muted) {
                sound.style.display = "none";
                muted.style.display = "block";
            } else {
                sound.style.display = "block";
                muted.style.display = "none";
            }
        }
    }

    video.addEventListener("playing", () => setInitial(), false);

    if (videos) {
        videos = videos.split(",");

        video.pause();
        if (maxWidth.matches) {
            source.src = videos[0];
        } else {
            source.src = videos.length > 1 ? videos[1] : videos[0];
        }
        video.load();
    }

    play && play.addEventListener("click", () => {
        setInitial();
        video.play();
    });

    pause && pause.addEventListener("click", () => {
        play.style.display = "block";
        pause.style.display = "none";
        if (poster) poster.style.position = "relative";
        video.pause();
    });

    const expandFunction = () => {
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
        }
    };

    expand?.addEventListener("click", () => expandFunction());
    video.addEventListener("dblclick", () => expandFunction());

    sound?.addEventListener("click", () => {
        video.muted = !video.muted;
        sound.style.display = "none";
        muted.style.display = "block";
    });

    muted?.addEventListener("click", () => {
        video.muted = !video.muted;
        sound.style.display = "block";
        muted.style.display = "none";
    });
});

// --- Responsive source for slide videos (markup from _partials/videoSlide.twig) ---

document.querySelectorAll("video[data-desktop-vid]").forEach((video) => {
    const src = maxWidth.matches ? video.dataset.mobileVid : video.dataset.desktopVid;
    if (!src) return;
    const source = document.createElement("source");
    source.src = src;
    source.type = "video/mp4";
    video.appendChild(source);
});

// --- Hover-to-play grids ---

document.querySelectorAll(".hover-videos").forEach((grid) => {
    const videoPlayer = grid.querySelector("video");
    if (!videoPlayer) return;

    grid.addEventListener("mouseover", () => {
        videoPlayer.play();
    });

    grid.addEventListener("mouseleave", () => {
        videoPlayer.pause();
    });
});
